// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.day {


    margin: 2px;
    text-align: center;
    line-height: 40px;
    border: 1px solid #ccc;
    background-color: white;
    cursor: pointer;
    transition: all 200ms ease-out;
    -webkit-user-select: none;
            user-select: none;
    padding: 0.3em 1em;

    font-weight: bold;
    border-radius: 1em;


}

.nope {
    background-color: rgb(216, 216, 216);
}


.day.selected {
    background-color: #3fa77f;
    border-radius: 1em;
    color: white;
}





.slots-container {

    overflow-y: scroll;
    scrollbar-width: 0;

    /* scrollbar-color: transparent; */
    background-color: rgb(179, 179, 179);
}

.slots-container::-webkit-scrollbar {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/myAccount/WorkingHoursManagement/Calendar.css"],"names":[],"mappings":"AAAA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,8BAA8B;IAC9B,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;;IAElB,iBAAiB;IACjB,kBAAkB;;;AAGtB;;AAEA;IACI,oCAAoC;AACxC;;;AAGA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;AAChB;;;;;;AAMA;;IAEI,kBAAkB;IAClB,kBAAkB;;IAElB,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".day {\n\n\n    margin: 2px;\n    text-align: center;\n    line-height: 40px;\n    border: 1px solid #ccc;\n    background-color: white;\n    cursor: pointer;\n    transition: all 200ms ease-out;\n    user-select: none;\n    padding: 0.3em 1em;\n\n    font-weight: bold;\n    border-radius: 1em;\n\n\n}\n\n.nope {\n    background-color: rgb(216, 216, 216);\n}\n\n\n.day.selected {\n    background-color: #3fa77f;\n    border-radius: 1em;\n    color: white;\n}\n\n\n\n\n\n.slots-container {\n\n    overflow-y: scroll;\n    scrollbar-width: 0;\n\n    /* scrollbar-color: transparent; */\n    background-color: rgb(179, 179, 179);\n}\n\n.slots-container::-webkit-scrollbar {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
